import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import CountUp from "react-countup";
import up from "../../../../assets/DigitalMarketing/image/dashboard/arrow_up.svg";
import down from "../../../../assets/DigitalMarketing/image/dashboard/arrow down.svg";
import { BsThreeDots } from "react-icons/bs";
import circle from "../../../../assets/DigitalMarketing/image/dashboard/circle_down.svg";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import chatbot from "../../../assets/DigitalMarketing/image/integration/cryptocurrency-color_chat.svg";
import vector from "../../../assets/DigitalMarketing/image/integration/Vector.svg";
import logo from "../../../assets/DigitalMarketing/image/integration/Group 1000002636.svg";
import "../../../assets/DigitalMarketing/Css/Style.css";
import {
  ChatBotLabel,
  WhatsAppLabel,
  templateLabel,
  templatesampleLabel,
} from "./utils";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import {
  useAddTemplateMutation,
  useAddwhatsappsettingMutation,
  useGetTemplatesettingQuery,
  useGetWhatsappsettingQuery,
} from "../../../Service/Integration";
import {
  updatetemplatesetting,
  updatewhatsappsetting,
} from "../../../store/reducers/digitalmarketing/customer";
import { validatePhone, validationChecking } from "./utils/validation";
import SelectMultiItem from "../Customer/Component/SelectMultiItem";
import SelectMenuItem from "./Component/SelectMenuItem";
import Tabs from "../../../Component/DigitalMarketing/Tabs";

function WhatsappDetail(props) {
  const { id, errorMessage, callBackforErrorMessage } = props;
  const [show, setshow] = useState(false);
  const dispatch = useDispatch<any>();
  const [searchValue, setSearchValue] = useState("");
  const [branchList, setBranchList] = useState([]);
  const { open, message, openSnackBar, type } = useSnackbar();
  const [stepone, setstepone] = useState(false);
  const [steptwo, setsteptwo] = useState(false);
  const [error, setError] = useState();
  const [active, setActive] = useState(1);
  const [submit, setSubmit] = useState(false);

  const [addwhatsappsetting,{ isLoading:addLoading }] = useAddwhatsappsettingMutation();
  const values = [
    { id: 1, name: "Settings" },
    { id: 2, name: "Template Setting" },
  ];
  const whatsappSettin = useSelector(
    (state: any) => state.customer.whatsappsetting
  );
  const templateSettin = useSelector(
    (state: any) => state.customer.templatesetting
  );
  const { data: whatsappSetting } = useGetWhatsappsettingQuery(id || "1", {
    refetchOnMountOrArgChange: true,
  });
  // console.log(whatsappSettin);
  // console.log(whatsappSetting);


  const { data: templateMaster } = useGetTemplatesettingQuery(id || "1", {
    refetchOnMountOrArgChange: true,
  });
  const remainder: { value: string; label: string; body: string }[] = [];
  const [addTemplate,{ isLoading:addLoading1 }] = useAddTemplateMutation();

  if (Array.isArray(templateMaster)) {
    for (const template of templateMaster) {
      remainder.push({
        value: template.id.toString(),
        label: template.templateName,
        body: template.templateBody,
      });
    }
  } else {
    // Handle the case where templateMaster is not an array (possibly undefined)
    console.error("templateMaster is not an array");
  }

  const savewhatsappsetting = async () => {
    setSubmit(true);
    if (
      whatsappSettin.apiKey.trim().length !== 0 &&
      whatsappSettin.appName.trim().length !== 0 &&
      whatsappSettin.channel.trim().length !== 0 &&
      validatePhone(whatsappSettin.sourceMobileNumber)
    ) {
      try {
        const res: any = await addwhatsappsetting(whatsappSettin).unwrap();
        openSnackBar(res.message, "success");
      } catch (err: any) {
        // console.log(err.response.data.error);
      }
    }
  };
  const handleChangeData = (e, validation) => {
    let { name, value } = e.target;
     if (name === 'sourceMobileNumber' || name==='adminMobileNumber' ) {
      value = value.replace(/^[\s]+|[^a-zA-Z0-9 ]/g, '');
      value = value.replace(/[^0-9]/g, '');
      value = value.slice(0, 10);
    }
    setError(validation);
    // console.log("whatsappsetting", whatsappSetting);
    setSubmit(false);
    dispatch(
      updatewhatsappsetting({
        [name]: value,
      })
    );
  };
  useEffect(() => {
    dispatch(
      updatewhatsappsetting({
        ...whatsappSetting,
      })
    );
  }, [whatsappSetting]);

  const data: any = {
    first: "Whatsapp",
  };

  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  // console.log(DashboardStatus);

  const CustomerDetail = useSelector(
    (state: any) => state.customer.customerDetail
  );
  const getValueByLabel = (label) => {
    let val = remainder.find((item) => item.label == label);
    if (val) {
      return val.value;
    }
    return 0;
  };
  const getLabelByValue = (value) => {
    let val = remainder.find((item) => item.value == value);
    if (val) {
      return val.label;
    }
    return "Created";
  };
  const getBodyByValue = (value) => {
    let val = remainder.find((item) => item.value == value);
    if (val) {
      return val.body;
    }
    return "Created";
  };
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    // console.log(event);
    // console.log(name);
    // console.log(value);

    dispatch(
      updatetemplatesetting({
        [name]: value,
        templateBody: getBodyByValue(value),
      })
    );
    // console.log(templateSettin);
  };
  const handletemplateidChange = (event) => {
    const { name, value } = event.target;
    // console.log(event);
    // console.log(name);
    // console.log(value);
    dispatch(
      updatetemplatesetting({
        [name]: value,
      })
    );
  };
  const UpdateTemplate = async () => {
    try {
      const res: any = await addTemplate(templateSettin).unwrap();
      openSnackBar(res.message, "success");
    } catch (err: any) {
      // console.log(err.data.error);
      openSnackBar(err.data.error, "error");
    }
  };
  dispatch(Change(data));
  return (
    <>
      <Toast open={open} type={type} message={message} />
      <Container fluid>
        <Row className="integration-whatsapplayout">
          <Col md={12}>
            <Tabs tablist={values} active={active} setActive={setActive} />
          </Col>
          <Col md={12} className="integration-whatsapp">
            <div className="mx-4">
              {active === 1 ? (
                <>
                  {WhatsAppLabel.map((item) => (
                    <div className="mt-3 w-50">
                      <item.tag
                        label={item.label}
                        name={item.key_name}
                        validation={item.validation}
                        handleChange={handleChangeData}
                        {...item}
                        submit={submit}
                        {...whatsappSettin}
                      />
                    </div>
                  ))}
                  <Button
                    onClick={() => {
                      savewhatsappsetting();
                    }}
                    variant="contained"
                    id="btn-chat"
                    className="whatsapp-btn mx-1" disabled={addLoading}
                  >
                    {addLoading?"Wait": !whatsappSetting?.appName ? "Save" : "Update"}
                  </Button>
                </>
              ) : (
                <>
                  <Row>
                    <Col md={6}>
                      <p className="mt-3">Reminders</p>

                      <SelectMenuItem
                        styles={"select"}
                        name="id"
                        option={remainder}
                        value={templateSettin.id || 0}
                        onChange={handleSelectChange}
                      />
                      {templateLabel.map((item) => (
                        <div className="mt-3 ">
                          <item.tag
                            label={item.label}
                            name={item.key_name}
                            validation={item.validation}
                            handleChange={handletemplateidChange}
                            {...item}
                          />
                        </div>
                      ))}
                      <Button
                        variant="contained"
                        id="btn-chat"
                        onClick={UpdateTemplate}
                        className="whatsapp-btn mx-1"
                      >
                        {addLoading1?"Wait":"Save"}
                      </Button>
                    </Col>
                    <Col md={6}>
                      {templatesampleLabel.map((item) => (
                        <div className="mt-3 ">
                          <item.tag
                            placeholder={templateSettin.templateBody}
                            disab={true}
                            value={templateSettin.templateBody}
                            label={item.label}
                            name={item.key_name}
                            validation={item.validation}
                            handleChange={handleChangeData}
                            {...item}
                          />
                        </div>
                      ))}
                    </Col>
                  </Row>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default React.memo(WhatsappDetail);
